//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { ENGINE_REST_PATH } from "@/assets/js/appConfig";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";

const defaultImage = require("@/assets/images/appDefault.svg");

export default {
    name: "FeaturePublicEnrollment",
    components: {
        AQButton,
        AQModal,
        AQDropdown,
        AQInput,
        AQRadio,
        AQCard
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        extraData: {
            type: Object,
            default: () => {}
        }

    },
    data() {
        return {
            opened: false,
            dataApps: [],
            currentSelectedApp: null,
            appsOptions: [],
            appsMod: [],
            draftApp: null,
            search: "",
            processesList: [],
            targetProcess: {}
        };
    },
    computed: {
        hasValue() {
            return this.value && (this.value.label || this.value.name) && this.value.process;
        },
        checkDisabled() {
            return !this.draftApp || (this.value && this.value.id === this.draftApp.id);
        },
        hasSave() {
            return {
                label: this.$t("generic.done"),
                disabled: this.checkDisabled || (this.draftApp && !this.draftApp.process)
            };
        },
        setBtnlabel() {
            return this.$t(`admin.labs.publicEnrollment.${this.hasValue ? "changeAppBtn" : "labelBtn"}`);
        },
        getAllAppsProps() {
            return {
                label: this.$t("appSetPermissions.appTitle"),
                options: this.appsOptions,
                clearable: true
            };
        },
        filterProcessList() {
            let processListToShow = [];
            if (this.search) {
                const lowerCaseValue = this.search.toLowerCase();
                processListToShow = this.processesList.filter(item => item.name && item.name.toLowerCase().includes(lowerCaseValue));
            } else {
                processListToShow = this.processesList;
            }
            return processListToShow;
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.currentSelectedApp = newValue;
                if (this.currentSelectedApp) {
                    this.appsMod = this.appsOptions.filter(el => el.id === this.currentSelectedApp.id);
                    this.targetProcess = this.currentSelectedApp.process.id;
                }
            },
            immediate: true
        }
    },
    created() {
        this.actPublicEnrollmentApps().then(
            data => {
                this.dataApps = data.data;
                this.appsOptions = this.dataApps.map(elem => ({
                    label: elem.name,
                    value: elem.id,
                    imageId: elem.imageId,
                    code: elem.code,
                    id: elem.id
                }));
                if (this.extraData && this.extraData.applicationId) {
                    const selectApp = this.dataApps.find(elem => elem.id === this.extraData.applicationId);
                    const processId = this.extraData.processDefinitionId || this.extraData.applicationId;
                    if (selectApp) {
                        this.getProcessesEnrollmentContext(selectApp.id).then(rsp => {
                            if (rsp.data.length) {
                                selectApp.process = rsp.data.find(el => el.id === processId);
                                this.$emit("input", selectApp);
                            }
                        });
                    }
                }
            }
        );
    },
    methods: {
        ...mapActions("admin", ["actPublicEnrollmentApps"]),
        ...mapActions("apps", ["getProcessesEnrollmentContext"]),
        setImage(app) {
            return app && app.imageId ? `${ENGINE_REST_PATH}/app/files/${app.imageId}/IMAGE` : defaultImage;
        },
        action(action) {
            if (action === "primary") {
                this.currentSelectedApp = { ...this.draftApp };
                if (!this.currentSelectedApp.process) {
                    this.currentSelectedApp.process = this.processesList.find(el => el.id === this.targetProcess);
                }
                this.$emit("input", this.currentSelectedApp);
            } else if (this.currentSelectedApp) {
                this.appsMod = this.appsOptions.filter(el => el.id === this.currentSelectedApp.id);
                this.targetProcess = this.currentSelectedApp.process.id;
            } else {
                this.appsMod = "";
                this.processesList = [];
                this.targetProcess = "";
            }
            this.draftApp = null;
            this.opened = false;
        },
        selectApplication(app) {
            this.search = "";
            [this.draftApp] = app;
            this.getProcessesEnrollmentContext(this.draftApp.id).then(rsp => {
                if (rsp.data.length) {
                    this.processesList = rsp.data;
                    if (this.processesList.length === 1) {
                        this.targetProcess = this.processesList[0].id;
                        [this.draftApp.process] = this.processesList;
                        if (!this.currentSelectedApp || this.draftApp.code !== this.currentSelectedApp.code) {
                            this.hasSave.disabled = false;
                        }
                    }
                    if (!this.targetProcess) {
                        this.hasSave.disabled = true;
                    }
                } else {
                    this.processesList = [];
                    this.targetProcess = "";
                }
            });
        },
        selectProcess(process) {
            this.draftApp.process = process;
            this.targetProcess = process.id;
            if (this.value && this.value.process) {
                this.hasSave.disabled = this.targetProcess === this.value.process.id;
            } else {
                this.hasSave.disabled = false;
            }
        }
    }
};
